import { orderStatusOptionsNew, orderTypeOptions, productTypeOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"
import ProductType from "types/enums/ProductType"

import { getProductTypeLabel } from "utils/getProductTypeLabel"
import OrderNumberCell from "components/table/columnComponents/OrderNumberCell"
import OrdersQuantity from "components/table/columnComponents/OrdersQuantity"
import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"
import { StatusOfOrderNew } from "components/table/columnComponents/StatusOfOrderNew"

export const getOrderTableHeaderCells = (
  isFulfillChecked: boolean,
  showV2: boolean = false,
  showSensors: boolean = false,
): UITypes.TableHeaderCell[] => {
  const deviceFilterOptions = productTypeOptions.filter(option => {
    if (!showV2 && option.value === ProductType.ThermostatV2) return false
    if (!showSensors && (option.value === ProductType.THS || option.value === ProductType.WLS)) return false
    return true
  })

  return [
    { title: "", size: "mini", name: "group_toggle", cellComponent: RowExpandToggle },
    {
      title: "Order number",
      type: "search-number",
      name: "item_id",
      size: "middle",
      cellComponent: OrderNumberCell,
    },
    {
      title: "Creation Date",
      type: "sort-date-range",
      name: "create_date",
      size: "small",
    },
    {
      title: "Shipping date",
      type: "date-range",
      name: "shipping_date",
      size: "small",
    },
    ...((isFulfillChecked
      ? [
          {
            title: "Fulfillment date",
            type: "date-range",
            name: "fulfillment_date",
            size: "middle",
          },
        ]
      : []) as UITypes.TableHeaderCell[]),
    {
      title: "Device",
      type: "select",
      name: "product_type",
      size: "middle",
      options: showV2
        ? deviceFilterOptions
        : deviceFilterOptions.map(option => ({
            ...option,
            label: getProductTypeLabel(option.value, true) ?? option.label,
          })),
    },
    {
      title: "Quantity",
      type: "search-number",
      name: "quantity",
      size: "middle",
      cellComponent: OrdersQuantity,
    },
    {
      title: "Order type",
      type: "select",
      name: "item_type",
      size: "small",
      options: orderTypeOptions,
    },
    {
      title: "Status",
      type: isFulfillChecked ? "default" : "select",
      name: "item_status",
      options: orderStatusOptionsNew,
      cellComponent: StatusOfOrderNew,
    },
    {
      title: "Warehouse",
      type: "search",
      name: "warehouse",
      size: "middle",
    },
  ]
}
